import { inject, Injectable } from '@angular/core';
import { CookieConsentService } from '@shared/services/cookie-consent/cookie-consent.service';
import { ANALYTICS_EVENTS } from '@shared/constants/analytics.constant';

declare global {
    interface Window {
        dataLayer?: Record<string, unknown>[];
    }
}

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    private readonly cookieConsentService = inject(CookieConsentService);

    trackPageView(pagePath: string, pageLocation: string, pageTitle?: string): void {
        this.push({
            event: ANALYTICS_EVENTS.VIRTUAL_PAGE_VIEW,
            page_path: pagePath,
            page_location: pageLocation,
            page_title: pageTitle ?? (typeof document !== 'undefined' ? document.title : '')
        });
    }

    trackEvent(event: string, params: Record<string, unknown> = {}): void {
        this.push({ event, ...params });
    }

    private push(payload: Record<string, unknown>): void {
        if (!this.cookieConsentService.allowsTracking()) {
            return;
        }

        if (typeof window === 'undefined') {
            return;
        }

        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push(payload);
    }
}
